"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sitesDetailStore = void 0;
const api_1 = require("client/api");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const ramda_1 = require("ramda");
const permissions_1 = require("shared/permissions");
class SitesDetailStore {
    constructor() {
        this.site = {};
        this.inventorysites = {};
        this.users = {};
        this.orders = {};
        this.pads = {};
        this.patients = {};
        this.distributors = {}; // Create an Interface for this after
        this.editPatients = {};
        this.providers = {};
        this.editProviders = {};
        this.submission = {};
        this.editDistributors = {}; // Create an Interface for this after
        this.submitted = false;
        this.siteDistributors = {
            error: "",
            loading: false,
            status: ui_1.FormStatus.Clean,
            value: []
        };
        this.loadSiteDistributors = async (query) => {
            this.siteDistributors.loading = true;
            const result = await api_1.SiteEndpoint.listsitedistributors.apiCall({ query });
            // console.log("this.siteDistributors before", this.siteDistributors);
            if (api_1.isError(result)) {
                alert("error in loading site distributors");
                this.siteDistributors.loading = false;
            }
            else {
                this.siteDistributors = Object.assign(Object.assign({}, this.siteDistributors), { loading: false, value: result.siteDistributors });
                // console.log("this.siteDistributors", this.siteDistributors);
            }
        };
        this.saveSiteDistributors = async (site, siteDistributors) => {
            this.siteDistributors = Object.assign(Object.assign({}, this.siteDistributors), { loading: true });
            const result = await api_1.SiteEndpoint.savesitedistributors.apiCall(null, {
                site,
                siteDistributors
            });
            if (api_1.isError(result)) {
                alert("error in saveing site distributors");
                this.siteDistributors = Object.assign(Object.assign({}, this.siteDistributors), { loading: false });
            }
            else {
                // console.log("reult from save site distributor is ", result);
                this.siteDistributors = Object.assign(Object.assign({}, this.siteDistributors), { loading: false });
            }
        };
        this.createSite = async (site) => {
            this.site = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.site.value
            };
            const result = await api_1.SiteEndpoint.create.apiCall(null, { site });
            if (api_1.isError(result)) {
                this.site = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.site.value
                };
                return false;
            }
            this.site = {
                status: ui_1.FormStatus.Saved,
                value: ramda_1.merge(site, result.site)
            };
            return result.site;
        };
        this.ledgerStartBalance = async (site) => {
            this.site = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.site.value
            };
            const result = await api_1.LedgerEndpoint.startbalanceledger.apiCall(null, {
                site
            });
            if (api_1.isError(result)) {
                this.site = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.site.value
                };
                return false;
            }
            return result;
        };
        this.enrollToErx = async (site) => {
            this.site = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.site.value
            };
            const result = await api_1.SiteEndpoint.enrolltoerx.apiCall(null, {
                site
            });
            if (api_1.isError(result)) {
                this.site = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.site.value
                };
            }
        };
        this.readSite = async (id) => {
            this.site = {
                loading: true,
                status: ui_1.FormStatus.Loading,
                value: this.site.value
            };
            const result = await api_1.SiteEndpoint.read.apiCall({
                params: { id }
            });
            if (api_1.isError(result)) {
                this.site = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.site.value
                };
            }
            else {
                this.site = { status: ui_1.FormStatus.Clean, value: result.site };
                this.totalPatientCount = result === null || result === void 0 ? void 0 : result.totalPatientsCount; //E-025
            }
        };
        this.readSiteForApproverEmail = async (id) => {
            const result = await api_1.SiteEndpoint.read.apiCall({
                params: { id }
            });
            if (api_1.isError(result)) {
                console.error("Error in readSiteForApproverEmail");
                return null;
            }
            return result.site;
        };
        this.saveSite = async (site) => {
            this.site = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.site.value
            };
            const result = await api_1.SiteEndpoint.save.apiCall(null, { site });
            if (api_1.isError(result)) {
                this.site = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.site.value
                };
            }
            else {
                this.site = {
                    status: ui_1.FormStatus.Saved,
                    value: ramda_1.merge(site, result.site)
                };
            }
        };
        this.createUserSiteUpdateRequest = async (uploadMeta, siteId) => {
            const formData = new FormData();
            uploadMeta.supportingDocuments.forEach(file => {
                formData.append("supportingDocuments", file);
            });
            formData.append("uploadMeta", JSON.stringify(uploadMeta));
            formData.append("siteId", JSON.stringify(siteId));
            const result = await api_1.SiteEndpoint.createusersiteupdaterequest.apiCall(null, formData);
            if (api_1.isError(result)) {
                console.error("Error creating user site update request", result);
            }
        };
        this.deleteSite = async (site) => {
            const result = await api_1.SiteEndpoint.remove.apiCall({
                params: { id: site.id }
            });
            if (api_1.isError(result)) {
                this.site = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.site.value
                };
                return false;
            }
            return true;
        };
        this.saveInventorySites = async (site, inventorySites) => {
            this.site = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.site.value
            };
            const result = await api_1.SiteEndpoint.saveinventories.apiCall(null, {
                inventorysites: inventorySites,
                site
            });
            if (api_1.isError(result)) {
                const isDev = store_1.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
                if (isDev) {
                    alert("Error Saving inventorysites. Check console");
                }
                console.error("Error saving inventorysites", result);
                this.site = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.site.value
                };
            }
            else {
                this.site.loading = false;
                this.site = { status: ui_1.FormStatus.Saved, value: ramda_1.merge(site, result.site) };
            }
        };
        this.saveInventorySite = async (site, inventorySite) => {
            this.site = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.site.value
            };
            const result = await api_1.SiteEndpoint.saveinventorysite.apiCall(null, {
                inventorysite: inventorySite,
                site
            });
            if (api_1.isError(result)) {
                this.site = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.site.value
                };
            }
            else {
                this.site = { status: ui_1.FormStatus.Saved, value: ramda_1.merge(site, result.site) };
            }
        };
        this.loadInventories = async (siteId, search) => {
            const result = await api_1.SiteEndpoint.listinventories.apiCall({
                query: { count: 100, id: siteId, search, start: 0 }
            });
            // console.log("result: ", result);
            if (api_1.isError(result)) {
                this.inventorysites = { error: result.code };
            }
            else {
                this.inventorysites = { value: result.inventorysites };
            }
        };
        this.loadUsers = async (query = { count: 100, id: 0, start: 0 }) => {
            const result = await api_1.SiteEndpoint.listusers.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.users = { error: result.code };
            }
            else {
                this.users = { value: result.users };
            }
        };
        this.loadContacts = async (query = { count: 100, id: 0, start: 0 }) => {
            const result = await api_1.SiteEndpoint.listcontacts.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.users = { error: result.code };
            }
            else {
                this.users = { value: result.users };
            }
        };
        this.saveContact = async (contact, siteId) => {
            const result = await api_1.SiteEndpoint.savecontact.apiCall(null, {
                contact,
                siteId
            });
            if (api_1.isError(result)) {
                console.log("Uh-oh.");
            }
        };
        this.deleteContact = async (id) => {
            const result = await api_1.SiteEndpoint.deletecontact.apiCall(null, { id });
            if (api_1.isError(result)) {
                console.log("Uh-oh.");
            }
        };
        this.loadOrders = async (siteId) => {
            const result = await api_1.SiteEndpoint.listorders.apiCall({
                query: { count: 100, id: siteId, start: 0 }
            });
            if (api_1.isError(result)) {
                this.orders = { error: result.code };
            }
            else {
                this.orders = { value: result.orders };
            }
        };
        this.loadPads = async (query = { count: 100, id: 0, start: 0 }) => {
            const result = await api_1.SiteEndpoint.listpads.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.pads = { error: result.code, status: ui_1.FormStatus.Error };
            }
            else {
                this.pads = {
                    status: this.pads.status || ui_1.FormStatus.Clean,
                    value: result.pads
                };
            }
        };
        this.loadPatientsLite = async (query) => {
            const result = await api_1.SiteEndpoint.listPatientsLite.apiCall(null, Object.assign({}, query));
            this.patients = api_1.isError(result)
                ? { error: result.code }
                : { value: result.patients };
        };
        this.loadPatients = async (query = {
            count: 150,
            id: 0,
            patientId: null,
            start: 0
        }) => {
            const result = await api_1.SiteEndpoint.listpatients.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.patients = { error: result.code, status: ui_1.FormStatus.Error };
            }
            else {
                this.patients = { status: ui_1.FormStatus.Clean, value: result.patients };
            }
        };
        this.loadEditPatients = async (query = { count: 100, id: 0, start: 0 }) => {
            this.editPatients = {
                loading: true,
                status: ui_1.FormStatus.Loading,
                value: this.editPatients.value
            };
            const result = await api_1.SiteEndpoint.listeditpatients.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.editPatients = { error: result.code, status: ui_1.FormStatus.Error };
            }
            else {
                this.editPatients = { status: ui_1.FormStatus.Clean, value: result.patients };
            }
        };
        this.loadDistributors = async (query = { count: 100, id: 0, start: 0 }) => {
            // Refactor Query to get the current distributors
            const result = await api_1.SiteEndpoint.listDistributors.apiCall({
                query
            });
            // console.log("load dists: ", result);
            if (api_1.isError(result)) {
                this.patients = { error: result.code, status: ui_1.FormStatus.Error };
            }
            else {
                this.patients = { status: ui_1.FormStatus.Clean, value: result.distributors };
                // console.log("Distributors in site order stores: ", toJS(this.patients));
            }
        };
        this.loadEditDistributors = async (query = { count: 100, id: 0, start: 0 }) => {
            this.editDistributors = {
                loading: true,
                status: ui_1.FormStatus.Loading,
                value: this.editPatients.value
            };
            // Refactor Query in endpoint
            const result = await api_1.SiteEndpoint.listeditpatients.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.editDistributors = { error: result.code, status: ui_1.FormStatus.Error };
            }
            else {
                this.editDistributors = {
                    status: ui_1.FormStatus.Clean,
                    value: result.patients
                };
            }
        };
        this.loadProvidersLite = async (query) => {
            const result = await api_1.SiteEndpoint.listProvidersLite.apiCall(null, Object.assign({}, query));
            this.providers = api_1.isError(result)
                ? { error: result.code }
                : { value: result.providers };
        };
        this.loadProviders = async (query = {
            count: 100,
            id: 0,
            providerId: null,
            start: 0
        }) => {
            const result = await api_1.SiteEndpoint.listProviders.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.providers = { error: result.code };
            }
            else {
                this.providers = { value: result.providers };
            }
        };
        this.loadEditProviders = async (query = { count: 100, id: 0, start: 0 }) => {
            this.editProviders = {
                loading: true,
                status: ui_1.FormStatus.Loading,
                value: this.editProviders.value
            };
            const result = await api_1.SiteEndpoint.listeditproviders.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.editProviders = { error: result.code, status: ui_1.FormStatus.Error };
            }
            else {
                this.editProviders = {
                    status: ui_1.FormStatus.Clean,
                    value: result.providers
                };
            }
        };
        this.provisionPad = async (pad, site) => {
            const result = await api_1.PadEndpoint.provisionpad.apiCall(null, {
                pad,
                site
            });
            if (api_1.isError(result)) {
                this.pads = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.pads.value
                };
            }
            else {
                this.pads = { status: ui_1.FormStatus.Saved, value: this.pads.value };
            }
        };
        this.unprovisionPad = async (pad) => {
            const result = await api_1.PadEndpoint.unprovisionpad.apiCall(null, {
                pad
            });
            if (api_1.isError(result)) {
                this.pads = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.pads.value
                };
            }
            else {
                this.pads = { status: ui_1.FormStatus.Saved, value: this.pads.value };
            }
        };
        this.savePad = async (pad) => {
            this.pads = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.pads.value
            };
            const result = await api_1.PadEndpoint.save.apiCall(null, {
                pad
            });
            if (api_1.isError(result)) {
                this.pads = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.pads.value
                };
            }
            else {
                this.pads = {
                    status: ui_1.FormStatus.Saved,
                    value: this.pads.value
                };
            }
        };
        this.savePatients = async (site, patientsAdded, patientsRemoved) => {
            this.editPatients = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.editPatients.value
            };
            const result = await api_1.SiteEndpoint.savepatients.apiCall(null, {
                patientsAdded,
                patientsRemoved,
                site: {
                    id: site.id,
                    patients: site.patients
                }
            });
            if (api_1.isError(result)) {
                this.editPatients = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.editPatients.value
                };
            }
            else {
                this.patients.value = [];
                if (this.editPatients.value) {
                    for (const patient of this.editPatients.value) {
                        if (patientsAdded.find(p => p.id === patient.id)) {
                            patient.sites.push(site);
                        }
                        if (patientsRemoved.find(p => p.id === patient.id)) {
                            patient.sites = patient.sites.filter(s => s.id !== site.id);
                        }
                        if (patient.sites.find(s => s.id === site.id)) {
                            this.patients.value.push(patient);
                        }
                    }
                }
                this.editPatients = {
                    status: ui_1.FormStatus.Saved,
                    value: this.editPatients.value
                };
            }
        };
        this.saveProviders = async (site, providersAdded, providersRemoved) => {
            this.editProviders = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.editProviders.value
            };
            const result = await api_1.SiteEndpoint.saveproviders.apiCall(null, {
                providersAdded,
                providersRemoved,
                site: {
                    id: site.id,
                    providers: site.providers
                }
            });
            if (api_1.isError(result)) {
                this.editProviders = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.editProviders.value
                };
            }
            else {
                this.providers.value = [];
                if (this.editProviders.value) {
                    for (const provider of this.editProviders.value) {
                        if (providersAdded.find(p => p.id === provider.id)) {
                            provider.sites.push(site);
                        }
                        if (providersRemoved.find(p => p.id === provider.id)) {
                            provider.sites = provider.sites.filter(s => s.id !== site.id);
                        }
                        if (provider.sites.find(s => s.id === site.id)) {
                            this.providers.value.push(provider);
                        }
                    }
                }
                this.editProviders = {
                    status: ui_1.FormStatus.Saved,
                    value: this.editProviders.value
                };
            }
        };
        this.upload = async (files, id, uploadType, idType // E-067
        ) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newFile", file); // Why is name gone?
            });
            formData.append("id", id);
            formData.append("idType", idType);
            formData.append("uploadType", uploadType);
            const response = await api_1.SiteEndpoint.uploadFile.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
                // E-067
                if (idType === "Eob") {
                    console.log("Eob upload successful");
                }
                if (idType === "Site") {
                    console.log("site upload successful");
                }
                // else {
                //   this.loadProviders();
                // }
            }
        };
        this.deleteUpload = async (uploadId) => {
            const result = await api_1.SiteEndpoint.removeFile.apiCall({
                params: { id: uploadId }
            });
        };
        this.saveCopay = async (copay) => {
            await api_1.SiteEndpoint.saveCopay.apiCall(null, { copay });
        };
        this.deleteCopay = async (copayId) => {
            await api_1.SiteEndpoint.deleteCopay.apiCall(null, { copayId });
        };
        this.readCopays = async (siteId) => {
            const response = await api_1.SiteEndpoint.readCopays.apiCall(null, { siteId });
            return response.copays;
        };
    }
}
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "site", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "totalPatientCount", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "inventorysites", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "users", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "orders", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "pads", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "patients", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "distributors", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "editPatients", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "providers", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "editProviders", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "submission", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "editDistributors", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "submitted", void 0);
__decorate([
    mobx_1.observable
], SitesDetailStore.prototype, "siteDistributors", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadSiteDistributors", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "saveSiteDistributors", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "createSite", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "ledgerStartBalance", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "enrollToErx", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "readSite", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "readSiteForApproverEmail", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "saveSite", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "createUserSiteUpdateRequest", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "deleteSite", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "saveInventorySites", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "saveInventorySite", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadInventories", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadUsers", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadContacts", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "saveContact", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "deleteContact", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadOrders", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadPads", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadPatientsLite", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadPatients", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadEditPatients", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadDistributors", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadEditDistributors", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadProvidersLite", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadProviders", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "loadEditProviders", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "provisionPad", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "unprovisionPad", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "savePad", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "savePatients", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "saveProviders", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "upload", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "deleteUpload", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "saveCopay", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "deleteCopay", void 0);
__decorate([
    mobx_1.action
], SitesDetailStore.prototype, "readCopays", void 0);
exports.sitesDetailStore = new SitesDetailStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/store.ts
// module id = 78
// module chunks = 0 1